import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.css' // 代码高亮的样式
import { ElMessage } from 'element-plus' // 导入消息提示组件

// 注册一个简单的'plain'语言，用于处理无语言指定的代码块
hljs.registerLanguage('plain', () => ({
    name: 'plain',
    case_insensitive: true,
    disableAutodetect: true,
    contains: []
}));

export const highLightPlugin = {
    install(app: any) {
        //定义全局指令
        app.directive('highlight', {
            mounted(el: any) {
                highlightCodeBlocks(el);
            },
            updated(el: any) {
                highlightCodeBlocks(el);
            }
        })
    }
}

// 提取出高亮处理函数，便于复用
function highlightCodeBlocks(el: any) {
    const blocks = el.querySelectorAll('pre code');
    blocks.forEach((block: any) => {
        // 如果代码块有language-plain类，使用plain语言
        if (block.classList.contains('language-plain')) {
            block.classList.remove('language-plain');
            block.classList.add('language-plaintext');
        }

        try {
            hljs.highlightElement(block);
        } catch (error) {
            console.warn('代码高亮处理失败:', error);
            // 降级处理：如果高亮失败，至少应用基本样式
            block.classList.add('hljs');
        }
    });

    // 添加复制按钮到代码块
    addCopyButtonsToCodeBlocks(el);
}

// 为代码块添加复制按钮
function addCopyButtonsToCodeBlocks(el: any) {
    const codeBlocks = el.querySelectorAll('pre code');

    codeBlocks.forEach((codeBlock: any) => {
        const preElement = codeBlock.parentNode;

        // 避免重复添加
        if (preElement.classList.contains('code-block-processed')) {
            return;
        }

        // 标记为已处理
        preElement.classList.add('code-block-processed');

        // 创建包装器
        const wrapper = document.createElement('div');
        wrapper.className = 'code-block-wrapper';

        // 设置包装器样式，使其成为相对定位的容器
        wrapper.style.position = 'relative';
        wrapper.style.marginBottom = '1.5em';
        wrapper.style.borderRadius = '8px';
        wrapper.style.overflow = 'hidden';

        // 创建复制按钮
        const copyButton = document.createElement('button');
        copyButton.className = 'code-copy-btn';
        copyButton.innerHTML = '<svg class="copy-icon" viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg><span>复制</span>';

        // 设置复制按钮样式，定位在右上角
        copyButton.style.position = 'absolute';
        copyButton.style.top = '8px';
        copyButton.style.right = '8px';
        copyButton.style.zIndex = '10';
        copyButton.style.padding = '4px 8px';
        copyButton.style.borderRadius = '4px';
        copyButton.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
        copyButton.style.border = '1px solid #e0e0e0';
        copyButton.style.fontSize = '12px';
        copyButton.style.color = '#666';
        copyButton.style.cursor = 'pointer';
        copyButton.style.display = 'flex';
        copyButton.style.alignItems = 'center';
        copyButton.style.gap = '4px';
        copyButton.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
        copyButton.style.transition = 'all 0.2s ease';

        // 添加悬停效果
        copyButton.addEventListener('mouseover', () => {
            copyButton.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
            copyButton.style.color = '#1976d2';
            copyButton.style.borderColor = '#1976d2';
            copyButton.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.2)';
        });

        copyButton.addEventListener('mouseout', () => {
            copyButton.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
            copyButton.style.color = '#666';
            copyButton.style.borderColor = '#e0e0e0';
            copyButton.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
        });

        // 添加点击事件处理复制功能
        copyButton.addEventListener('click', (event) => {
            event.stopPropagation();
            const codeText = codeBlock.textContent;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(codeText)
                    .then(() => {
                        const originalBgColor = copyButton.style.backgroundColor;
                        const originalColor = copyButton.style.color;
                        const originalBorderColor = copyButton.style.borderColor;
                        const originalText = copyButton.innerHTML;

                        copyButton.style.backgroundColor = '#e3f2fd';
                        copyButton.style.color = '#1976d2';
                        copyButton.style.borderColor = '#1976d2';
                        copyButton.innerHTML = '<svg class="copy-icon" viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span>已复制</span>';

                        ElMessage.success('代码已复制到剪贴板');

                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.style.backgroundColor = originalBgColor;
                            copyButton.style.color = originalColor;
                            copyButton.style.borderColor = originalBorderColor;
                        }, 2000);
                    })
                    .catch(err => {
                        console.error('复制失败:', err);
                        ElMessage.error('复制失败，请手动复制');
                    });
            } else {
                // 降级方案：使用 document.execCommand
                const textarea = document.createElement('textarea');
                textarea.value = codeText;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand('copy');
                    ElMessage.success('代码已复制到剪贴板');
                } catch (err) {
                    console.error('降级复制失败:', err);
                    ElMessage.error('复制失败，请手动复制');
                }
                document.body.removeChild(textarea);
            }
        });

        // 将pre元素放入包装器
        preElement.parentNode.insertBefore(wrapper, preElement);
        wrapper.appendChild(preElement);

        // 添加复制按钮到包装器（直接添加到包装器，不创建header元素）
        wrapper.appendChild(copyButton);

        // 设置pre元素的样式，增加顶部padding为复制按钮留出空间
        preElement.style.paddingTop = '40px';
        preElement.style.margin = '0';
    });
}


